import React from 'react'
import styled from 'styled-components'
import AboutInfoItems from '../components/AboutInfoItem';



const SkillsStyles = styled.div`
    padding: 5rem 0;
    .about__info__heading{
        font-size:2.5rem;
    }
`;
export default function Skills() {
    return (
        <SkillsStyles>
            <div className="container">
                <div className="about__info__item">
                    <h1 className="about__info__heading">Skills</h1>

                    <AboutInfoItems
                        title="FrontEnd"
                        items={['HTML', 'CSS', 'REACT', 'SASS']}
                    />
                    <AboutInfoItems
                        title="BackEnd"
                        items={['Node', 'Express', 'MongoDB', 'Firebase']}
                    />
                    <AboutInfoItems
                        title="Android"
                        items={['Flutter', 'Dart', 'Unity']}
                    />
                    <AboutInfoItems
                        title="Languages"
                        items={['C', 'C++', 'JavaScript']}
                    />
                </div>
            </div>
        </SkillsStyles>
    )
}
